import { DiseasePleiotropyIndex } from '../../AboutHelpers.tsx';
import { FormulaAccordion } from './components/FormulaAccordion';
import { MetricRangeVisual } from './components/MetricRangeVisual';

const DPI_PINS = [
  {
    value: 0.17,
    label: 'KCNT1',
    sublabel: '5 out of 29 MeSH classes — narrow pleiotropy',
  },
  {
    value: 0.93,
    label: 'APOE',
    sublabel: '27 out of 29 MeSH classes — broad pleiotropy',
  },
];

function AboutMetricsPleiotropy(): JSX.Element {
  return (
    <div id="pleiotropy">
      <h3>Disease Pleiotropy Index</h3>
      <p>
        The Disease Pleiotropy Index (DPI) measures whether the multiple diseases associated to a gene (or
        variant) belong to the same MeSH disease class or to completely different classes. DPI ranges from 0
        to 1, where higher values indicate associations spanning more disease classes.
      </p>
      <MetricRangeVisual
        min={0}
        max={1}
        pins={DPI_PINS}
        lowLabel="Low pleiotropy (few disease classes)"
        highLabel="High pleiotropy (many disease classes)"
        color="#8B5CF6"
      />
      <p className="text-sm text-gray-500 mt-1">
        If the gene/variant has no DPI value, it is associated only to phenotypes or the associated diseases
        do not map to any MeSH classes.
      </p>
      <FormulaAccordion label="View formula">
        <span>{DiseasePleiotropyIndex()}</span>
        <div className="mt-3 text-sm text-gray-600">
          <dt className="font-medium">where:</dt>
          <ul className="mt-1 space-y-1">
            <li>
              N<sub>dc</sub> — number of different MeSH disease classes of the associated diseases
            </li>
            <li>
              N<sub>TC</sub> — total number of MeSH disease classes in DISGENET (29)
            </li>
          </ul>
        </div>
      </FormulaAccordion>
    </div>
  );
}

export default AboutMetricsPleiotropy;
